var map = {
	"./WELEDA_Logo_2024_SC_PMS_Light_Vivid_Green.eps": 32,
	"./cz": 13,
	"./cz.png": 13,
	"./czech-republic": 14,
	"./czech-republic.svg": 14,
	"./en": 15,
	"./en.png": 15,
	"./packshot_image_background": 16,
	"./packshot_image_background.png": 16,
	"./placeholder_image": 17,
	"./placeholder_image.png": 17,
	"./polish": 18,
	"./polish.png": 18,
	"./slovakia": 19,
	"./slovakia.svg": 19,
	"./sort": 20,
	"./sort.png": 20,
	"./weleda_logo": 21,
	"./weleda_logo.pdf": 33,
	"./weleda_logo.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;